// getCurrentUser.js
import { getAuth } from 'firebase/auth';

export const getCurrentUser =  () => {
  const auth =  getAuth();
  const user = auth.currentUser;
console.log(auth.currentUser)
  if (user) {
    return {
      uid: user.uid,
      name: user.displayName,
      email: user.email,
      photo: user.photoURL,
      phone: user.phoneNumber,
      emailVerified: user.emailVerified,
      providerId: user.providerId,
    };
  } else {
    return null;
  }
};
